/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popUpGold.vue?vue&type=template&id=77cc2c58&scoped=true"
import script from "./popUpGold.vue?vue&type=script&lang=js"
export * from "./popUpGold.vue?vue&type=script&lang=js"
import style0 from "./popUpGold.vue?vue&type=style&index=0&id=77cc2c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cc2c58",
  null
  
)

export default component.exports